import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/pro-solid-svg-icons';

import LoadingSpinner from 'components/ui/loading_spinner';

import DuplicatesPageHeader from './duplicates_page_header';
import DuplicatesPageTopbar from './duplicates_page_topbar';
import DuplicatesTable from './duplicates_table';

import { getDuplicatePropertiesCount, isLoading } from '../../store/selectors/duplicates';
import DuplicatesPagination from 'bundles/research/index/properties/duplicates/duplicates_pagination';
import { Empty } from '@buildoutinc/blueprint-react/ui/Empty';

function renderEmptyState() {
  return (
    <div className="p-4" name="no-results-card">
      <Empty className="bg-white">
        <Empty.Media>
          <FontAwesomeIcon icon={faSearch} />
        </Empty.Media>
        <Empty.Title>No duplicate properties found</Empty.Title>
      </Empty>
    </div>
  );
}

function renderTable() {
  return (
    <div className="d-flex flex-column flex-grow-1 overflow-hidden">
      <DuplicatesTable />
      <DuplicatesPagination />
    </div>
  );
}

function renderResults(isLoading, totalCount) {
  if (isLoading) return <LoadingSpinner />;
  if (totalCount > 0) return renderTable();
  return renderEmptyState();
}

export function DuplicatePropertiesView({ isLoading, totalCount }) {
  return (
    <>
      <DuplicatesPageHeader />
      <DuplicatesPageTopbar />
      {renderResults(isLoading, totalCount)}
    </>
  );
}

DuplicatePropertiesView.propTypes = {
  isLoading: PropTypes.bool,
  totalCount: PropTypes.number.isRequired
};

const mapStateToProps = state => ({
  isLoading: isLoading(state),
  totalCount: getDuplicatePropertiesCount(state)
});

export default connect(mapStateToProps)(DuplicatePropertiesView);
